import { Link } from "@mui/material";
import { useDispatch } from "react-redux";
import { clearActiveTab } from "../../../../redux/features/TabsManager/tabSlice";
import { useLocation, useNavigate } from "react-router-dom";
import {
  PartRequestManagemenProvider,
  PartRequestManagementContext,
} from "../../context/PartRequestManagementContext";
import { PermissionsProvider } from "../../../../contexts/PermissionsContext";
import { NavBar } from "../../../../components/NavBar/NavBar";
import { useContext, useEffect, useRef, useState } from "react";
import Filters from "../../../../components/Filters/Filters";
import { usePermissions } from "../../../../hooks/usePermissions";
import { DropdownsProvider } from "../../../../contexts/DropdownsContext";
import "./PartRequest.css";
import { PartRequestList } from "./PartRequestList/PartRequestList";
import { PRFilters } from "./PRFilters";
import { DialogContext } from "../../../../contexts/DialogContext";
import NewOrder from "../Orders/NewOrder";
import CustomTabs from "../../../../components/Tabs/Tabs";
import NewQuote from "../Quotes/NewQuote";
import QuoteOrderConfirmation from "../Quotes/QuoteOrderConfirmation";
import { FiltersManager } from "../../../../components/FiltersManager/FiltersManager";
import { SortingProvider } from "../../../../contexts/SortingContext";
import { SortingButton } from "../../../../components/Sorting/SortingButton";
const FilterContainer = ({ filtersOpen, setFiltersOpen }) => {
  const { onFiltersChange } = useContext(PartRequestManagementContext);
  return (
    <PRFilters
      extOpen={filtersOpen}
      openChange={(value) => setFiltersOpen(value)}
      onApplyFilters={onFiltersChange}
      hideToggle
    />
  );
};
const SearchBarContainer = () => {
  const [inputValue, setInputValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");
  const { onSearch } = useContext(PartRequestManagementContext);

  const didMount = useRef(false);
  const handleChange = (event) => {
    setInputValue(event.target.value);
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, 500); // 500ms delay

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true; // Evita la primera ejecución
      return;
    }
    onSearch(debouncedValue);
  }, [debouncedValue]);
  return <input placeholder="Search" onChange={handleChange} />;
};
const AddButtonContainer = () => {
  const { addType, partsToOrder, setUpdateInfoList, setPartsToOrder } =
    useContext(PartRequestManagementContext);
  const { hasPermission } = usePermissions();

  const { openDialog, closeDialog } = useContext(DialogContext);
  const saveSuccess = () => {
    setUpdateInfoList(new Date().getTime());
    setPartsToOrder([]);
  };

  const onNewOrder = () => {
    openDialog({
      component: NewOrder,
      props: {
        parts: partsToOrder,
        close: closeDialog,
        okAction: () => saveSuccess(),
      },
    });
  };
  const onNewQuote = () => {
    openDialog({
      component: NewQuote,
      props: {
        parts: partsToOrder,
        close: closeDialog,
        okAction: (quote, vendors) =>
          confirmQuote(quote, vendors, partsToOrder),
      },
    });
  };
  const confirmQuote = (quote, vendors, parts) => {
    setUpdateInfoList(new Date().getTime());
    setPartsToOrder([]);
    openDialog({
      component: QuoteOrderConfirmation,
      props: {
        parts: parts,
        vendors: vendors,
        quote: quote,
        close: closeDialog,
        okAction: (vendors) => confirmQuote(vendors, partsToOrder),
      },
    });
  };
  return (
    hasPermission("create") && (
      <div className="buttons-container-order-actions">
        <button
          onClick={() => onNewQuote()}
          className={`filled iconTextButton greenButton ${
            partsToOrder.length == 0 ? "disabled" : ""
          }`}
        >
          <i className="icon-quote"></i> <span>Quote PRN</span>
        </button>
        <button
          onClick={() => onNewOrder()}
          className={`filled iconTextButton ${
            partsToOrder.length == 0 ? "disabled" : ""
          }`}
        >
          <i className="icon-stores"></i> <span>New Order</span>
          <div className="cant-to-order">
            <p>PN</p>
            <div>{partsToOrder.length}</div>
          </div>
        </button>
      </div>
    )
  );
};
export const PartRequestManagement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [updateInfoList, setUpdateInfoList] = useState(null);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const dataBreadCrumbs = [
    <Link
      key={1}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => {
        dispatch(clearActiveTab());
        navigate("/secure/customdashboard");
      }}
    >
      Modules
    </Link>,
    <Link
      key={2}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => {
        dispatch(clearActiveTab());
        navigate("/secure/supplychain");
      }}
    >
      Supply Chain
    </Link>,
    <Link
      key={3}
      underline="none"
      sx={{ color: "#000000", cursor: "default", fontSize: "var(--p-size)" }}
    >
      Part Request Management
    </Link>,
  ];

  return (
    <PartRequestManagemenProvider>
      <PermissionsProvider resourceId={14}>
        <SortingContainer>
        <div className="part-request-shop-component">
          <div className="nav-header">
            <NavBarContainer
              dataBreadCrumbs={"/supplychain/part-request-management"}
              dynamicTitle={"Part Request"}
              appIcon={"icon-part_request_icon"}
              moduleIcon={"icon-settings"}
              moduleColor="#4F79C2"
              title={" Part Request Management"}
              menuTitle={"Configuration"}
              moduleId={12}
              isLocalSearch
              searchActions={
                <>
                  <FiltersManager
                    onButtonClick={() => setFiltersOpen((prev) => !prev)}
                  />
                   <SortingButton />
                </>
              }
              screenActions={
                <>
                  <AddButtonContainer />
                </>
              }
            />
            {/* <button
              onClick={() => setFiltersOpen((prev) => !prev)}
              className="filter-toggle"
            >
              <h2>Filters</h2>
              <i className={`icon-arrow-down ${filtersOpen ? "open" : ""}`}></i>
            </button> */}
          </div>
          <div className="part-request-shop-component-content">
            <div className="content-header">
              <FilterContainer
                filtersOpen={filtersOpen}
                setFiltersOpen={setFiltersOpen}
              />

              <div className="part-request-header">
                {/* <span className="left-container">
                  <b>Part Request</b>
                  <div className="search-bar-input">
                    <SearchBarContainer />
                    <i className="icon-search"></i>
                  </div>
                </span> */}
                {/* <AddButtonContainer/> */}
              </div>
            </div>
            <DropdownsProvider>
              <PartRequestList></PartRequestList>
            </DropdownsProvider>
          </div>
          <div className="paginator-container"></div>
        </div>
        </SortingContainer>
      </PermissionsProvider>
    </PartRequestManagemenProvider>
  );
};

const NavBarContainer = ({ ...props }) => {
  const { onSearch, dataList } = useContext(PartRequestManagementContext);
  return (
    <NavBar
    displayRecordsCount={true}
      totalRecords={dataList?.length}
      searchInputProps={{ onTextChange: (e) => onSearch(e) }}
      {...props}
    />
  );
};

const SortingContainer = ({ children }) => {
  const { setSortingOrder } = useContext(PartRequestManagementContext);

  return (
    <SortingProvider
      onOrderChange={(e) => setSortingOrder(e)}
      properties={{
        id: "PRN",
        part_number: "PN",
        quantity: "Required",
        issued_quantity_posted: "Issued",
        remaining_quantity: "Remaining",
        available_quantity: "Available",
        pending_order: "Pending Order",
        pending_transfer: "Pending Transfer",
        other_locations_avl: "Other Locations AVL",
        pending_quotes: "Pending Quotes",
        pr_location_id: "Location",
        pr_site_id: "Site",
        company_id: "Company",
        date_request_required: "Required Date",
      }}
    >
      {children}
    </SortingProvider>
  );
};
